import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';

interface SkeletonCardProps {
  rows?: number;
  height?: string;
  title?: string;
  showHeader?: boolean;
  columns?: number;
  columnSizes?: string[];
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({ 
  rows = 3, 
  height = '200px', 
  showHeader = true,
  columns = 2,
  columnSizes
}) => {
  // Calculate default column sizes if not provided
  const defaultColumnSize = Math.floor(12 / columns);
  const defaultColumnSizes = Array.from({ length: columns }, () => `col-${defaultColumnSize}`);
  const finalColumnSizes = columnSizes || defaultColumnSizes;
  return (
    <Card className="skeleton-card">
      {showHeader && (
        <CardHeader className="d-flex justify-content-between align-items-center">
          <div className="placeholder-glow">
            <span className="placeholder col-6"></span>
          </div>
          <div className="placeholder-glow">
            <span className="placeholder col-2"></span>
          </div>
        </CardHeader>
      )}
      <CardBody>
        <div className="placeholder-glow">
          {Array.from({ length: rows }).map((_, index) => (
            <div key={index} className="row mb-3">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <div key={colIndex} className={finalColumnSizes[colIndex]}>
                  <span className="placeholder w-100"></span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default SkeletonCard;
